'use client';

import { Component, type ReactNode } from 'react';
import type { DeferredRequestKey } from '~/constants/common/deferredRequests';
import { generateErrorLogger } from '~/utilities/loggers';

type OwnProps = {
  children: ReactNode;
  deferredKey: DeferredRequestKey;
  onError?: () => void;
};

type OwnState = {
  hasError: boolean;
};

const logError = generateErrorLogger('Deferred Stream Error Boundary');

class DeferredErrorBoundary extends Component<OwnProps, OwnState> {
  constructor(props: OwnProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logError(error, { location: `${this.props.deferredKey} Deferred Stream` });
    this.props.onError?.();
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default DeferredErrorBoundary;
